(function(app) {

    app.filter('numberSuffix', function () {
        return function (input, decimals) {
            var exp, rounded,
              /*suffixes = ['k', 'M', 'G', 'T', 'P', 'E'];*/
            //updating G to B from Giga to Billion as most don't use Giga for that number
            
            suffixes = ['k', 'M', 'B', 'T', 'P', 'E'];

            if (window.isNaN(input)) {
                return null;
            }

            if (input < 1000) {
                return input;
            }

            exp = Math.floor(Math.log(input) / Math.log(1000));

            return (input / Math.pow(1000, exp)).toFixed(decimals) + suffixes[exp - 1];
        };
    });

})(window.app); //jshint ignore:line